export default __webpack_public_path__ + "static/media/chart-home-delivery.364e7080.svg";